export default function checkIsVariantShownInQuery(variantReference, query) {
  if (!query.show_variants) return false;

  const showVariants = query.show_variants
    .split(',')
    .map(variant => variant.trim());

  return showVariants.includes(variantReference);
}
